import { render, staticRenderFns } from "./CoFileInput.vue?vue&type=template&id=011c8870&scoped=true&"
import script from "./CoFileInput.vue?vue&type=script&lang=ts&"
export * from "./CoFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./CoFileInput.vue?vue&type=style&index=0&id=011c8870&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c8870",
  null
  
)

export default component.exports